export default __webpack_public_path__ + "static/media/floatButtonClose.ec02dead.svg";